import generateJavaRequest from './services/jrequest';

const jUserRequest = generateJavaRequest('user');

/**
 * 获取用户地址列表
 * @param {*} conditions
 */
export function getAddressList(conditions) {
  return jUserRequest('address/list', conditions);
}

/**
 * 编辑用户地址
 * @param {*} conditions
 */
export function editAddress(conditions) {
  return jUserRequest('add/address', conditions, {
    method: 'post',
  });
}

/**
 * 删除用户地址
 * @param {*} conditions
 */
export function deleteAddress(conditions) {
  return jUserRequest('delete/address', conditions);
}

/**
 * 获取用户浏览历史
 * @param {*} conditions
 */
export function getBrowHistory(conditions) {
  return jUserRequest('browse/history', conditions);
}

/**
 * 获取用户信息
 * @param {*} conditions
 */
export function getUserInfo() {
  return jUserRequest('info');
}

/**
 * 获取用户端上积分
 * @param {*} conditions
 */
export function getUserIntegral() {
  return jUserRequest('integral');
}

/**
 * 获取用户聚宝盆金币余额
 * @param {*} conditions
 */
export function getUserJbpCoin() {
  return jUserRequest('jbpCoin');
}

/**
 * 获取微信支付code
 * @param {*} conditions
 */
export function getWeixinCode(conditions) {
  return jUserRequest('weixin/code', conditions);
}

/**
 * 获取微信openId
 * @param {*} conditions
 */
export function getWeixinOpenId(conditions) {
  return jUserRequest('weixin/openid', conditions);
}
